const $ = require("jquery");

const ROLE_QUESTION = "Sind Sie Geschädigte/r bzw. Anzeigeerstatter/in oder werden Sie beschuldigt/als Beschuldigte/r geführt?";
const FINE_NOTICE_QUESTION = "Haben Sie bereits einen Bußgeldbescheid erhalten?";
const UNCLEAR_MESSAGE = "Das Anliegen kann noch nicht eindeutig zugeordnet werden. Bitte präzisieren Sie, was passiert ist, wer beteiligt ist und welches Ziel Sie verfolgen.";

function getConfig() {
    return window.AI_MATCHER_UI || {};
}

function getUrlParam(name) {
    try {
        return new URLSearchParams(window.location.search).get(name);
    } catch (e) {
        return null;
    }
}

function readCasePrefill() {
    const intentFromUrl = (getUrlParam("intent") || "").trim();
    const fromAi = getUrlParam("from_ai") === "1";
    let stored = null;

    if ("sessionStorage" in window) {
        try {
            stored = JSON.parse(sessionStorage.getItem("ai_matcher_case_prefill") || "null");
        } catch (e) {
            stored = null;
        }
    }

    if (!stored || typeof stored !== "object") {
        return intentFromUrl ? { intent: intentFromUrl, answer: "", open_points: [], fromAi } : null;
    }

    const createdAt = Number(stored.created_at || 0);
    const isFresh = createdAt && (Date.now() - createdAt < 30 * 60 * 1000);
    if (!isFresh && intentFromUrl) {
        return { intent: intentFromUrl, answer: "", open_points: [], fromAi };
    }

    return {
        intent: (stored.intent || intentFromUrl || "").trim(),
        answer: (stored.answer || "").trim(),
        open_points: Array.isArray(stored.open_points) ? stored.open_points : [],
        fromAi: true
    };
}

function buildPrefillText(prefill) {
    if (!prefill) return "";

    return prefill.intent || "";
}

function buildAnalysisContext(prefill) {
    if (!prefill) return "";

    const parts = [];
    if (prefill.intent) {
        parts.push(`Anliegen: ${prefill.intent}`);
    }
    if (prefill.answer) {
        parts.push(`Vorherige KI-Einschätzung: ${prefill.answer}`);
    }
    if (prefill.open_points && prefill.open_points.length) {
        parts.push(`Offene Punkte: ${prefill.open_points.join("; ")}`);
    }

    return parts.join("\n\n");
}

function isPdf(file) {
    if (!file) return false;
    const name = (file.name || "").toLowerCase();
    return name.endsWith(".pdf") && (!file.type || file.type === "application/pdf");
}

function setField($form, selector, value, overwrite = true) {
    const $field = $form.find(selector);
    if (!$field.length || typeof value !== "string" || value.trim() === "") return;
    if (!overwrite && ($field.val() || "").trim() !== "") return;
    $field.val(value).trigger("input").trigger("change");
}

function setLabel($form, selector, value) {
    const clean = (value || "").trim();
    const $label = $form.find(selector);
    if (!$label.length || !clean) return;
    $label.text(clean.endsWith("*") ? clean : `${clean}*`);
}

function setSelectByTextOrValue($form, selector, value) {
    const clean = (value || "").trim();
    const $select = $form.find(selector);
    if (!$select.length || !clean) return;

    const normalized = clean.toLowerCase();
    let matched = "";

    $select.find("option").each(function () {
        const $option = $(this);
        const optionValue = ($option.val() || "").trim();
        const optionText = ($option.text() || "").trim();

        if (optionValue.toLowerCase() === normalized || optionText.toLowerCase() === normalized) {
            matched = optionValue;
            return false;
        }

        return true;
    });

    if (matched) {
        $select.val(matched).trigger("change");
    }
}

function escapeHtml(value) {
    return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

function sanitizePhoneNumber(value) {
    return String(value || "").replace(/\D/g, "");
}

function selectLegalArea($form, legalArea) {
    if (!legalArea || !legalArea.slug) return;

    const $select = $form.find('select[name="f_rechtsgebiet"]');
    if (!$select.length) return;

    let matchedValue = "";
    $select.find("option").each(function () {
        const $option = $(this);
        const slug = ($option.data("slug") || "").toString();
        const text = ($option.text() || "").trim();
        const value = ($option.val() || "").trim();

        if (slug === legalArea.slug || text === legalArea.name || value === legalArea.name) {
            matchedValue = $option.val();
            return false;
        }

        return true;
    });

    if (matchedValue) {
        $select.val(matchedValue).trigger("change");
    }
}

function attachPdfToFinalForm(file) {
    if (!file) return;

    const finalInput = document.getElementById("f_file_input");
    if (!finalInput || typeof DataTransfer === "undefined") return;

    const dt = new DataTransfer();
    Array.from(finalInput.files || []).forEach((existingFile) => {
        if (existingFile.name !== file.name || existingFile.size !== file.size) {
            dt.items.add(existingFile);
        }
    });
    dt.items.add(file);
    finalInput.files = dt.files;
    finalInput.dispatchEvent(new Event("change", { bubbles: true }));
}

function appendText($field, text) {
    const clean = (text || "").trim();
    if (!clean) return;

    const current = ($field.val() || "").trim();
    $field.val(current ? `${current}\n\n${clean}` : clean).trigger("input");
}

function setLiveSpeechText($field, baseText, transcript) {
    const base = (baseText || "").trim();
    const spoken = (transcript || "").trim();
    const value = base && spoken ? `${base}\n\n${spoken}` : (base || spoken);
    $field.val(value).trigger("input");
}

function getSpeechRecognitionConstructor() {
    return window.SpeechRecognition || window.webkitSpeechRecognition || null;
}

function isSafariBrowser() {
    const ua = navigator.userAgent || "";
    return /Safari/i.test(ua) && !/Chrome|Chromium|CriOS|FxiOS|Edg|OPR/i.test(ua);
}

function normalizeQuestionText(value) {
    return String(value || "")
        .toLowerCase()
        .replace(/^[\s\-–—*•]+/, "")
        .replace(/\*/g, "")
        .replace(/\s+/g, " ")
        .replace(/[:?]+$/g, "")
        .trim();
}

function isQuestionExcluded(question, excludedQuestions) {
    const normalizedQuestion = normalizeQuestionText(question);
    if (!normalizedQuestion || !Array.isArray(excludedQuestions)) return false;

    return excludedQuestions.some((excludedQuestion) => normalizeQuestionText(excludedQuestion) === normalizedQuestion);
}

function getQuestionPartFromLine(line) {
    const clean = String(line || "").trim().replace(/^[\s\-–—*•]+/, "").trim();
    const colonIndex = clean.indexOf(":");
    return colonIndex > -1 ? clean.slice(0, colonIndex) : clean;
}

function hasInlineAnswer(line) {
    const clean = String(line || "").trim();
    const colonIndex = clean.indexOf(":");
    return colonIndex > -1 && clean.slice(colonIndex + 1).trim() !== "";
}

function removeAnsweredQuestionsFromText(text, excludedQuestions) {
    if (!text || !Array.isArray(excludedQuestions) || !excludedQuestions.length) {
        return (text || "").trim();
    }

    const lines = String(text).split(/\r?\n/);
    const keptLines = [];
    let skipNextAnswer = false;

    lines.forEach((line) => {
        const clean = line.trim();

        if (skipNextAnswer) {
            if (!clean) return;
            if (!hasInlineAnswer(clean) && clean.length <= 120) {
                skipNextAnswer = false;
                return;
            }
            skipNextAnswer = false;
        }

        if (isQuestionExcluded(getQuestionPartFromLine(line), excludedQuestions)) {
            skipNextAnswer = !hasInlineAnswer(line);
            return;
        }

        keptLines.push(line);
    });

    return keptLines.join("\n").replace(/\n{3,}/g, "\n\n").trim();
}

function buildMessageFromAnalysis(data, answers, excludedQuestions = []) {
    const fields = data.form_fields || {};
    const legalArea = data.legal_area || {};
    const lines = [];
    const messageText = removeAnsweredQuestionsFromText(fields.nachricht, excludedQuestions);
    const supplementalAnswers = (answers || []).filter((item) => {
        return item.answer && !isQuestionExcluded(item.question, excludedQuestions);
    });

    if (legalArea.name) {
        lines.push(`Rechtsgebiet: ${legalArea.name}`);
    }

    if (data.summary) {
        lines.push(`Zusammenfassung: ${data.summary}`);
    }

    if (messageText) {
        lines.push(`Anliegen: ${messageText}`);
    }

    if (supplementalAnswers.length) {
        lines.push("Ergänzende Angaben:");
        supplementalAnswers.forEach((item) => {
            lines.push(`- ${item.question}: ${item.answer}`);
        });
    }

    return lines.join("\n\n");
}

function findAnswerForQuestion(answers, question) {
    const target = (question || "").trim();
    if (!target || !Array.isArray(answers)) return "";

    const match = answers.find((item) => (item.question || "").trim() === target);
    return match && match.answer ? match.answer.trim() : "";
}

function hasAnswerForQuestion(answers, question) {
    return findAnswerForQuestion(answers, question) !== "";
}

function isRoleClarificationQuestion(question) {
    const normalized = String(question || "").toLowerCase();
    return normalized.includes("beschuldigt")
        || normalized.includes("beschuldigte")
        || normalized.includes("anzeigeerstatter")
        || normalized.includes("geschädigt")
        || normalized.includes("geschaedigt");
}

function isFineNoticeQuestion(question) {
    const normalized = String(question || "")
        .toLowerCase()
        .replace(/ß/g, "ss");

    return normalized.includes("bussgeldbescheid")
        || (normalized.includes("bescheid") && normalized.includes("erhalten"));
}

function normalizedAnalysisText(data) {
    const legalArea = data.legal_area || {};
    return [
        data.summary,
        legalArea.name,
        legalArea.slug,
        legalArea.reason
    ].map((value) => String(value || "").toLowerCase()).join(" ");
}

function hasMeaningfulLegalArea(data) {
    const legalArea = data.legal_area || {};
    const name = String(legalArea.name || "").trim();
    const slug = String(legalArea.slug || "").trim();
    const confidence = Number(legalArea.confidence || 0);

    if (!name && !slug) return false;
    if (confidence > 0 && confidence < 0.35) return false;

    return !/^(nicht erkannt|unklar|kein rechtsgebiet|keines|nicht zugeordnet)$/i.test(name);
}

function isAnalysisUnclear(data) {
    if (!data) return true;

    const text = normalizedAnalysisText(data);
    const unclearPatterns = [
        "allgemeine testanfrage",
        "testanfrage",
        "keine spezifischen",
        "ohne spezifische",
        "unklar",
        "nicht eindeutig",
        "kein konkretes rechtsgebiet",
        "kein konkreter sachverhalt",
        "nicht zugeordnet",
        "nicht sicher bestimmbar",
        "keine rechtlichen informationen",
        "nicht ausreichend"
    ];

    if (!hasMeaningfulLegalArea(data)) return true;
    return unclearPatterns.some((pattern) => text.includes(pattern));
}

function shouldShowRoleQuestion(data) {
    if (isAnalysisUnclear(data)) return false;

    const openPoints = Array.isArray(data.open_points) ? data.open_points : [];
    const text = normalizedAnalysisText(data);

    return openPoints.some(isRoleClarificationQuestion)
        || /straf|anzeige|beschuldigt|polizei|betrug|diebstahl|körperverletzung|koerperverletzung|vorladung/.test(text);
}

function shouldShowFineNoticeQuestion(data) {
    if (isAnalysisUnclear(data)) return false;

    const openPoints = Array.isArray(data.open_points) ? data.open_points : [];
    const text = normalizedAnalysisText(data);

    return openPoints.some(isFineNoticeQuestion)
        || /bußgeld|bussgeld|ordnungswidrig|fahrverbot|blitzer|punkte in flensburg/.test(text);
}

function buildClarificationQuestions(data) {
    if (isAnalysisUnclear(data)) return [];

    const fields = data.form_fields || {};
    const openPoints = Array.isArray(data.open_points) ? data.open_points : [];
    const proposedQuestions = [fields.frage_1, fields.frage_2]
        .map((question) => (question || "").trim())
        .filter(Boolean);
    const roleQuestions = openPoints.filter(isRoleClarificationQuestion);
    const otherQuestions = openPoints.filter((point) => !isRoleClarificationQuestion(point));
    const questions = [];

    roleQuestions.concat(proposedQuestions, otherQuestions).forEach((question) => {
        const clean = (question || "").trim();
        if (clean && !questions.includes(clean)) {
            questions.push(clean);
        }
    });

    return questions.slice(0, 6);
}

function getQuestionPair(data, answers) {
    const fields = data.form_fields || {};
    const questions = buildClarificationQuestions(data);
    const hasRoleAnswer = hasAnswerForQuestion(answers, ROLE_QUESTION);
    const hasFineNoticeAnswer = hasAnswerForQuestion(answers, FINE_NOTICE_QUESTION);
    const question1 = (hasRoleAnswer ? ROLE_QUESTION : (fields.frage_1 || questions[0] || "Bitte beschreiben Sie Ihr Anliegen.")).trim();
    const question2 = (hasFineNoticeAnswer ? FINE_NOTICE_QUESTION : (fields.frage_2 || questions.find((question) => question !== question1) || "Welche Unterlagen oder Nachweise liegen Ihnen vor?")).trim();

    return {
        question1,
        question2,
        answer1: findAnswerForQuestion(answers, question1),
        answer2: findAnswerForQuestion(answers, question2)
    };
}

function getWizard($form) {
    const $wizard = $form.closest("[data-intake-wizard]");
    return $wizard.length ? $wizard : $("[data-intake-wizard]").first();
}

function setWizardStep($wizard, step) {
    if (!$wizard.length) return;

    const total = 3;
    const stepNames = {
        1: "Anliegen schildern",
        2: "Angaben prüfen",
        3: "Anfrage senden"
    };
    const current = Math.max(1, Math.min(total, Number(step) || 1));
    const percent = Math.round((current / total) * 100);

    $wizard.attr("data-current-step", current);
    $wizard.find("[data-wizard-step]").each(function () {
        const $step = $(this);
        const isActive = Number($step.data("wizard-step")) === current;
        $step.toggleClass("is-active", isActive).prop("hidden", !isActive);
    });
    $wizard.find("[data-current-step]").text(current);
    $wizard.find("[data-step-name]").text(stepNames[current]);
    $wizard.find("[data-step-progress]").css("width", `${percent}%`);
    $wizard.find("[data-wizard-back]").prop("hidden", current === 1);
    const isUnclearReview = current === 2 && $wizard.attr("data-analysis-state") === "unclear";
    $wizard.find("[data-wizard-next]")
        .prop("hidden", false)
        .html(current === 3
            ? 'Anfrage einreichen <span aria-hidden="true">→</span>'
            : (isUnclearReview ? 'Anliegen präzisieren <span aria-hidden="true">←</span>' : 'weiter <span aria-hidden="true">→</span>'));
}

function renderInlineReview($wizard, data) {
    const legalArea = data.legal_area || {};
    const openPoints = Array.isArray(data.open_points) ? data.open_points : [];
    const isUnclear = isAnalysisUnclear(data);
    const filteredOpenPoints = openPoints.filter((point) => {
        return point
            && point !== ROLE_QUESTION
            && point !== FINE_NOTICE_QUESTION
            && !isRoleClarificationQuestion(point)
            && !isFineNoticeQuestion(point);
    });
    const showArea = !isUnclear && hasMeaningfulLegalArea(data);
    const showRole = shouldShowRoleQuestion(data);
    const showFineNotice = shouldShowFineNoticeQuestion(data);
    const showOpenPoints = !isUnclear && filteredOpenPoints.length > 0;
    const $review = $wizard.find(".intake-review");
    const $clarify = $wizard.find("[data-clarify-panel]");

    $wizard.attr("data-analysis-state", isUnclear ? "unclear" : "ready");
    $review.prop("hidden", isUnclear).toggle(!isUnclear);
    $clarify.prop("hidden", !isUnclear).toggle(isUnclear);
    $wizard.find("[data-clarify-message]").text(UNCLEAR_MESSAGE);
    $wizard.find("[data-review-area-item]").prop("hidden", !showArea).toggle(showArea);
    $wizard.find("[data-review-summary-item]").prop("hidden", isUnclear).toggle(!isUnclear);
    $wizard.find("[data-review-area]").text(legalArea.name || "");
    $wizard.find("[data-review-summary]").text(data.summary || "Keine Zusammenfassung vorhanden.");

    $wizard.find('[data-choice-group="role"]')
        .prop("hidden", !showRole)
        .toggle(showRole)
        .attr("data-selected-value", "");
    $wizard.find('[data-choice-group="fine_notice"]')
        .prop("hidden", !showFineNotice)
        .toggle(showFineNotice)
        .attr("data-selected-value", "");
    $wizard.find("[data-choice-value]").removeClass("is-selected");

    const $openPoints = $wizard.find("[data-open-points]");
    const $openPointsWrap = $wizard.find(".intake-open-points");
    $openPoints.empty();

    filteredOpenPoints.slice(0, 4).forEach((point, index) => {
        const id = `intake-open-point-${index}`;
        $(`
            <label class="intake-open-point" for="${id}">
                <span>${escapeHtml(point)}</span>
                <input id="${id}" type="text" data-open-point-answer="${index}" data-question="${escapeHtml(point)}" placeholder="Antwort ergänzen">
            </label>
        `).appendTo($openPoints);
    });

    $openPointsWrap.prop("hidden", !showOpenPoints).toggle(showOpenPoints);
}

function collectInlineAnswers($wizard) {
    const answers = [];

    $wizard.find("[data-choice-group]").each(function () {
        const $group = $(this);
        if ($group.prop("hidden") || !$group.is(":visible")) return;

        const value = ($group.attr("data-selected-value") || "").trim();
        const question = $group.data("choice-group") === "role" ? ROLE_QUESTION : FINE_NOTICE_QUESTION;

        if (value) {
            answers.push({ question, answer: value });
        }
    });

    $wizard.find("[data-open-point-answer]").each(function () {
        const $input = $(this);
        const answer = ($input.val() || "").trim();
        const question = ($input.attr("data-question") || "").trim();

        if (answer && question) {
            answers.push({ question, answer });
        }
    });

    return answers;
}

function applyInlineAnalysis($wizard) {
    const data = $wizard.data("analysisData");
    if (!data) return false;
    if (isAnalysisUnclear(data)) return false;

    fillFinalForm(data, $wizard.data("analysisSource") || "ki-panel-text", {
        answers: collectInlineAnswers($wizard),
        contact: {}
    });

    const file = $wizard.data("analysisFile");
    if ($wizard.find('input[name="attach_to_request"]').prop("checked") && file) {
        attachPdfToFinalForm(file);
    }

    return true;
}

function fillFinalForm(data, source, modalData = {}) {
    const $form = $("#legalRequestForm");
    if (!$form.length || !data) return;
    if (isAnalysisUnclear(data)) return;

    const legalArea = data.legal_area || {};
    const answers = Array.isArray(modalData.answers) ? modalData.answers : [];
    const contact = modalData.contact || {};
    const questionPair = getQuestionPair(data, answers);
    const message = buildMessageFromAnalysis(data, answers, [
        questionPair.question1,
        questionPair.question2
    ]);

    selectLegalArea($form, legalArea);
    setLabel($form, "#lbl_frage_1", questionPair.question1);
    setLabel($form, "#lbl_frage_2", questionPair.question2);
    setField($form, 'input[name="f_frage_1_label"]', questionPair.question1);
    setField($form, 'input[name="f_frage_2_label"]', questionPair.question2);
    setField($form, 'input[name="f_frage_1"]', questionPair.answer1);
    setField($form, 'input[name="f_frage_2"]', questionPair.answer2);
    setField($form, 'input[name="f_telefon"]', sanitizePhoneNumber(contact.phone));
    setSelectByTextOrValue($form, 'select[name="f_versicherung"]', contact.insurance || "");
    setField($form, 'textarea[name="f_nachricht"]', message || data.summary || "");

    setField($form, 'input[name="f_rechtsgebiet_ai"]', legalArea.name || "");
    setField($form, 'input[name="f_rechtsgebiet_ai_slug"]', legalArea.slug || "");
    setField($form, 'input[name="f_ai_confidence"]', String(legalArea.confidence || ""));
    setField($form, 'textarea[name="f_ai_summary"]', data.summary || "");
    setField($form, 'input[name="f_ai_source"]', source || "ki-panel");
}

function renderAnalysisModal(data, onApply) {
    const legalArea = data.legal_area || {};
    const questions = buildClarificationQuestions(data);
    const requiredQuestionCount = questions.length;

    const questionsHtml = questions.map((point, index) => `
        <label class="intake-question${isRoleClarificationQuestion(point) ? " is-priority" : ""}">
            ${isRoleClarificationQuestion(point) ? '<em>Wichtige Klärung</em>' : ""}
            <span>${escapeHtml(point)}${index < requiredQuestionCount ? " *" : ""}</span>
            <textarea data-question-index="${index}" rows="2" placeholder="Ihre Antwort"></textarea>
        </label>
    `).join("");

    const insuranceOptions = $('#legalRequestForm select[name="f_versicherung"] option').map(function () {
        const value = ($(this).val() || "").trim();
        const text = ($(this).text() || "").trim();
        const label = value ? text : "Keine / noch nicht bekannt";
        return `<option value="${escapeHtml(value)}">${escapeHtml(label)}</option>`;
    }).get().join("");

    const html = `
        <div class="intake-analysis-preview">
            <p><strong>Erkanntes Rechtsgebiet:</strong><br>${escapeHtml(legalArea.name || "Nicht erkannt")}</p>
            <p><strong>Zusammenfassung:</strong><br>${escapeHtml(data.summary || "Keine Zusammenfassung vorhanden.")}</p>
            <div class="intake-question-track">
                <strong>Bitte ergänzen Sie die wichtigsten Informationen:</strong>
                ${questionsHtml}
            </div>
            <div class="intake-question-track intake-contact-track">
                <strong>Kontaktdaten für die Anfrage:</strong>
                <label class="intake-question">
                    <span>Telefonnummer *</span>
                    <input data-intake-field="phone" type="tel" inputmode="numeric" pattern="[0-9]*" autocomplete="tel-national">
                </label>
                <label class="intake-question">
                    <span>Rechtsschutzversicherung, sofern vorhanden</span>
                    <select data-intake-field="insurance">${insuranceOptions}</select>
                </label>
            </div>
        </div>
    `;

    if (window.Swal && typeof window.Swal.fire === "function") {
        window.Swal.fire({
            title: "Angaben ergänzen",
            html,
            showCancelButton: true,
            confirmButtonText: "Ins Formular übernehmen",
            cancelButtonText: "Nicht übernehmen",
            confirmButtonColor: "#f87060",
            width: 760,
            preConfirm: function () {
                const answers = questions.map((question, index) => {
                    const input = document.querySelector(`.swal2-container [data-question-index="${index}"]`);
                    return {
                        question,
                        answer: input ? input.value.trim() : ""
                    };
                });
                const phoneInput = document.querySelector('.swal2-container [data-intake-field="phone"]');
                const insuranceInput = document.querySelector('.swal2-container [data-intake-field="insurance"]');
                const missingRequiredAnswer = answers.slice(0, requiredQuestionCount).find((item) => !item.answer);
                const phone = sanitizePhoneNumber(phoneInput ? phoneInput.value : "");

                if (phoneInput) {
                    phoneInput.value = phone;
                }

                if (missingRequiredAnswer) {
                    window.Swal.showValidationMessage("Bitte beantworten Sie die Pflichtfragen der Analyse.");
                    return false;
                }

                if (!phone) {
                    window.Swal.showValidationMessage("Bitte geben Sie Ihre Telefonnummer an.");
                    return false;
                }

                return {
                    answers,
                    contact: {
                        phone,
                        insurance: insuranceInput ? insuranceInput.value.trim() : ""
                    }
                };
            }
        }).then((result) => {
            if (result.isConfirmed) {
                onApply(result.value || { answers: [], contact: {} });
            }
        });
        return;
    }

    if (window.confirm("Analyse ins Formular übernehmen?")) {
        onApply([]);
    }
}

function renderResult($root, data) {
    const legalArea = data.legal_area || {};
    const $result = $root.find(".intake-ai-result");
    const $title = $root.find(".intake-ai-result-title");
    const $summary = $root.find(".intake-ai-result-summary");
    const $points = $root.find(".intake-ai-open-points");

    if (isAnalysisUnclear(data)) {
        $title.text("Anliegen noch nicht eindeutig zuordenbar");
        $summary.text(UNCLEAR_MESSAGE);
    } else {
        $title.text(legalArea.name ? `Erkanntes Rechtsgebiet: ${legalArea.name}` : "Analyse abgeschlossen");
        $summary.text(data.summary || "");
    }

    $points.empty();

    (isAnalysisUnclear(data) ? [] : (data.open_points || [])).forEach((point) => {
        if (typeof point === "string" && point.trim() !== "") {
            $("<li />").text(point).appendTo($points);
        }
    });

    $result.prop("hidden", false);
}

function initIntakeAssistant() {
    const cfg = getConfig();
    const endpoint = (cfg.intakeEndpoint || "").trim();
    const transcribeEndpoint = (cfg.transcribeEndpoint || "").trim();
    const maxPdfBytes = Number(cfg.maxPdfBytes || 10 * 1024 * 1024);
    const $form = $("#ai-intake-form");

    if (!$form.length || !endpoint) return;

    const $text = $form.find(".intake-ai-input");
    const $file = $form.find(".intake-ai-file");
    const $attach = $form.find('input[name="attach_to_request"]');
    const $attachOption = $attach.closest(".intake-ai-attach");
    const $status = $form.find(".intake-ai-status");
    const $loader = $form.find(".intake-ai-loader");
    const $submit = $form.find(".intake-ai-submit");
    const $voice = $form.find(".intake-ai-voice");
    const $wizard = getWizard($form);
    const phoneSelector = '#legalRequestForm input[name="f_telefon"], input[name="telefon"], .swal2-container [data-intake-field="phone"]';
    let lastAnalyzedFile = null;
    let mediaRecorder = null;
    let mediaStream = null;
    let audioChunks = [];
    let isRecording = false;
    let recognition = null;
    let isRecognizing = false;
    let speechBaseText = "";
    let speechFinalText = "";
    let lastRecordingMimeType = "";

    $(phoneSelector).attr({
        inputmode: "numeric",
        pattern: "[0-9]*",
        autocomplete: "tel-national"
    });

    setWizardStep($wizard, 1);

    window.smartRechtIntakeWizard = window.smartRechtIntakeWizard || {};
    window.smartRechtIntakeWizard.goToStep = function (step) {
        setWizardStep($wizard, step);
    };

    $wizard.on("smartrecht:caseRestored", function () {
        setWizardStep($wizard, 3);
    });

    if ($wizard.attr("data-case-restored") === "1") {
        setWizardStep($wizard, 3);
    }

    $wizard.on("click", "[data-choice-value]", function () {
        const $button = $(this);
        const $group = $button.closest("[data-choice-group]");
        $group.attr("data-selected-value", $button.data("choice-value") || "");
        $group.find("[data-choice-value]").removeClass("is-selected");
        $button.addClass("is-selected");
    });

    $wizard.on("click", "[data-edit-step]", function () {
        setWizardStep($wizard, Number($(this).data("edit-step")) || 1);
        $text.trigger("focus");
    });

    $wizard.on("click", "[data-wizard-back]", function () {
        const current = Number($wizard.attr("data-current-step") || 1);
        setWizardStep($wizard, Math.max(1, current - 1));
    });

    $wizard.on("click", "[data-wizard-next]", function () {
        const current = Number($wizard.attr("data-current-step") || 1);

        if (current === 1) {
            runAnalysis();
            return;
        }

        if (current === 2) {
            if ($wizard.attr("data-analysis-state") === "unclear") {
                setWizardStep($wizard, 1);
                $text.trigger("focus");
                return;
            }

            if (applyInlineAnalysis($wizard)) {
                setWizardStep($wizard, 3);
            }
            return;
        }

        if (current === 3) {
            const finalForm = document.getElementById("legalRequestForm");
            if (finalForm && typeof finalForm.requestSubmit === "function") {
                finalForm.requestSubmit();
                return;
            }

            const button = document.getElementById("mainSubmitBtn");
            if (button) {
                button.click();
            }
        }
    });

    $(document)
        .off("input.intakePhone", phoneSelector)
        .on("input.intakePhone", phoneSelector, function () {
            const clean = sanitizePhoneNumber(this.value);
            if (this.value !== clean) {
                this.value = clean;
            }
        });

    function selectedPdfFile() {
        return $file.get(0).files && $file.get(0).files[0] ? $file.get(0).files[0] : null;
    }

    function updateAttachOption(file) {
        const hasValidPdf = file && isPdf(file) && file.size <= maxPdfBytes;
        $attachOption.prop("hidden", !hasValidPdf);

        if (!hasValidPdf) {
            $attach.prop("checked", false);
        }
    }

    updateAttachOption(selectedPdfFile());

    $file.on("change", function () {
        const file = this.files && this.files[0] ? this.files[0] : null;
        updateAttachOption(file);
        if (!file) return;

        if (!isPdf(file)) {
            this.value = "";
            updateAttachOption(null);
            window.alert("Bitte laden Sie ausschließlich PDF-Dateien hoch.");
            return;
        }

        if (file.size > maxPdfBytes) {
            this.value = "";
            updateAttachOption(null);
            window.alert("PDFs dürfen maximal 10 MB groß sein.");
        }
    });

    function runAnalysis(queryOverride) {
        const file = selectedPdfFile();
        const query = (queryOverride || $text.val() || "").trim();

        if (!query && !file) return;
        if (file && (!isPdf(file) || file.size > maxPdfBytes)) return;

        const fd = new FormData();
        fd.append("query", query);
        if (file) {
            fd.append("document", file, file.name);
        }

        $submit.prop("disabled", true);
        $status.text("Analyse läuft...").prop("hidden", false);
        $loader.prop("hidden", false);
        $form.addClass("is-analyzing");
        $wizard.attr("data-analysis-state", "pending");

        fetch(endpoint, {
            method: "POST",
            credentials: "same-origin",
            headers: cfg.restNonce ? { "X-WP-Nonce": cfg.restNonce } : {},
            body: fd
        })
            .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
            .then(({ ok, data }) => {
                if (!ok) {
                    throw new Error(data && data.message ? data.message : "Die Analyse ist fehlgeschlagen.");
                }

                lastAnalyzedFile = file;
                $wizard.data("analysisData", data);
                $wizard.data("analysisSource", file ? "ki-panel-pdf" : "ki-panel-text");
                $wizard.data("analysisFile", file || null);
                renderInlineReview($wizard, data);
                renderResult($form, data);
                setWizardStep($wizard, 2);
                $status.text("Analyse bereit. Bitte prüfen Sie die Angaben.");
            })
            .catch((error) => {
                $status.text(error.message || "Die Analyse ist fehlgeschlagen.");
            })
            .finally(() => {
                $submit.prop("disabled", false);
                $loader.prop("hidden", true);
                $form.removeClass("is-analyzing");
            });
    }

    function supportedAudioType() {
        if (!window.MediaRecorder || typeof MediaRecorder.isTypeSupported !== "function") {
            return "";
        }

        const types = [
            "audio/webm;codecs=opus",
            "audio/webm",
            "audio/mp4;codecs=mp4a.40.2",
            "audio/mp4",
            "audio/aac"
        ];

        for (let i = 0; i < types.length; i++) {
            if (MediaRecorder.isTypeSupported(types[i])) {
                return types[i];
            }
        }

        return "";
    }

    function audioFilename(type) {
        if (type.indexOf("mp4") > -1) return "aufnahme.m4a";
        if (type.indexOf("aac") > -1) return "aufnahme.m4a";
        if (type.indexOf("mpeg") > -1 || type.indexOf("mp3") > -1) return "aufnahme.mp3";
        if (type.indexOf("wav") > -1) return "aufnahme.wav";
        return "aufnahme.webm";
    }

    function transcribeAudio(blob) {
        if (!transcribeEndpoint || !blob || !blob.size) return;

        const fd = new FormData();
        const type = blob.type || lastRecordingMimeType || (isSafariBrowser() ? "audio/mp4" : "audio/webm");
        fd.append("audio", blob, audioFilename(type));

        $voice.prop("disabled", true);
        $status.text("Aufnahme wird transkribiert...").prop("hidden", false);

        fetch(transcribeEndpoint, {
            method: "POST",
            credentials: "same-origin",
            headers: cfg.restNonce ? { "X-WP-Nonce": cfg.restNonce } : {},
            body: fd
        })
            .then((response) => response.json().then((data) => ({ ok: response.ok, data })))
            .then(({ ok, data }) => {
                if (!ok) {
                    throw new Error(data && data.message ? data.message : "Die Aufnahme konnte nicht transkribiert werden.");
                }

                appendText($text, data.text || "");
                $status.text("Transkription übernommen. Analyse läuft...");
                runAnalysis();
            })
            .catch((error) => {
                $status.text(error.message || "Die Aufnahme konnte nicht transkribiert werden.");
            })
            .finally(() => {
                $voice.prop("disabled", false);
            });
    }

    function stopBrowserSpeechRecognition() {
        if (!recognition || !isRecognizing) return;
        isRecognizing = false;
        $voice.text("Sprache aufnehmen").removeClass("is-recording");
        recognition.stop();
    }

    function startBrowserSpeechRecognition() {
        const Recognition = getSpeechRecognitionConstructor();
        if (!Recognition) return false;

        speechBaseText = ($text.val() || "").trim();
        speechFinalText = "";
        recognition = new Recognition();
        recognition.lang = "de-DE";
        recognition.continuous = true;
        recognition.interimResults = true;

        recognition.onstart = function () {
            isRecognizing = true;
            $voice.text("Aufnahme stoppen").addClass("is-recording");
            $status.text("Aufnahme läuft...").prop("hidden", false);
        };

        recognition.onresult = function (event) {
            let interimText = "";

            for (let i = event.resultIndex; i < event.results.length; i++) {
                const transcript = event.results[i][0] && event.results[i][0].transcript ? event.results[i][0].transcript : "";
                if (event.results[i].isFinal) {
                    speechFinalText = `${speechFinalText} ${transcript}`.trim();
                } else {
                    interimText = `${interimText} ${transcript}`.trim();
                }
            }

            setLiveSpeechText($text, speechBaseText, `${speechFinalText} ${interimText}`.trim());
        };

        recognition.onerror = function () {
            const shouldFallbackToRecorder = transcribeEndpoint && navigator.mediaDevices && window.MediaRecorder;
            isRecognizing = false;
            $voice.text("Sprache aufnehmen").removeClass("is-recording");
            if (shouldFallbackToRecorder) {
                startRecording();
                return;
            }
            $status.text("Spracherkennung wurde beendet.").prop("hidden", false);
        };

        recognition.onend = function () {
            const finalValue = ($text.val() || "").trim();
            isRecognizing = false;
            $voice.text("Sprache aufnehmen").removeClass("is-recording");

            if (finalValue && finalValue !== speechBaseText) {
                $status.text("Transkription übernommen. Analyse läuft...");
                runAnalysis();
            }
        };

        try {
            recognition.start();
            return true;
        } catch (e) {
            recognition = null;
            isRecognizing = false;
            return false;
        }
    }

    function stopMediaStream() {
        if (!mediaStream) return;
        mediaStream.getTracks().forEach((track) => track.stop());
        mediaStream = null;
    }

    function stopRecording() {
        if (!mediaRecorder || !isRecording) return;
        mediaRecorder.stop();
        isRecording = false;
        $voice.text("Sprache aufnehmen").removeClass("is-recording");
    }

    function startRecording() {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia || !window.MediaRecorder) {
            $status.text("Sprachaufnahme wird von diesem Browser nicht unterstützt.").prop("hidden", false);
            return;
        }

        navigator.mediaDevices.getUserMedia({ audio: true })
            .then((stream) => {
                mediaStream = stream;
                audioChunks = [];
                const type = supportedAudioType();
                lastRecordingMimeType = type;

                try {
                    mediaRecorder = type ? new MediaRecorder(stream, { mimeType: type }) : new MediaRecorder(stream);
                    lastRecordingMimeType = mediaRecorder.mimeType || type;
                } catch (e) {
                    stopMediaStream();
                    $status.text("Sprachaufnahme wird von diesem Browser nicht unterstützt.").prop("hidden", false);
                    return;
                }

                mediaRecorder.addEventListener("dataavailable", (event) => {
                    if (event.data && event.data.size) {
                        audioChunks.push(event.data);
                    }
                });

                mediaRecorder.addEventListener("stop", () => {
                    const blobType = mediaRecorder.mimeType || lastRecordingMimeType || (isSafariBrowser() ? "audio/mp4" : "audio/webm");
                    const blob = new Blob(audioChunks, { type: blobType });
                    stopMediaStream();
                    transcribeAudio(blob);
                });

                mediaRecorder.start();
                isRecording = true;
                $voice.text("Aufnahme stoppen").addClass("is-recording");
                $status.text("Aufnahme läuft...").prop("hidden", false);
            })
            .catch(() => {
                stopMediaStream();
                $status.text("Mikrofonzugriff wurde nicht erlaubt.").prop("hidden", false);
            });
    }

    $form.on("submit", function (event) {
        event.preventDefault();
        runAnalysis();
    });

    if (
        $voice.length &&
        (getSpeechRecognitionConstructor() || (transcribeEndpoint && navigator.mediaDevices && window.MediaRecorder))
    ) {
        $voice.prop("hidden", false);
        $voice.on("click", function () {
            if (isRecognizing) {
                stopBrowserSpeechRecognition();
            } else if (isRecording) {
                stopRecording();
            } else {
                if (isSafariBrowser() || !startBrowserSpeechRecognition()) {
                    startRecording();
                }
            }
        });
    }

    const prefill = readCasePrefill();
    const prefillText = buildPrefillText(prefill);
    if (prefillText) {
        $text.val(prefillText).trigger("input");

        if ("sessionStorage" in window) {
            try {
                sessionStorage.removeItem("ai_matcher_case_prefill");
            } catch (e) {}
        }

        window.setTimeout(() => {
            runAnalysis(buildAnalysisContext(prefill));
        }, 350);
    }
}

$(document).ready(initIntakeAssistant);
module.exports = initIntakeAssistant;
